import { Injectable } from '@angular/core';

const SPRITE_URL = 'assets/icons/sprite.svg';

@Injectable({
  providedIn: 'root',
})
export class SvgSpriteLoaderService {
  /**
   * Injects the sprite into the document once, so every <use> resolves its
   * symbol locally (#icon-name) instead of fetching the sprite per icon.
   */
  public async load(): Promise<void> {
    try {
      const response = await fetch(SPRITE_URL);
      if (!response.ok) {
        throw new Error(`Failed to load ${SPRITE_URL}: ${response.status}`);
      }
      const container = document.createElement('div');
      container.style.display = 'none';
      container.setAttribute('aria-hidden', 'true');
      container.innerHTML = await response.text();
      document.body.appendChild(container);
    } catch (error) {
      // Icons will not render, but the app must still boot.
      console.error(error);
    }
  }
}
